// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MWrn","type":"styles_type__1Ko2-","choices":"styles_choices__pRX6M"};